/* <cv-sticky-atc> — sticky add-to-cart bar (mobile + desktop).
   Shows once the main offer's primary CTA has scrolled out of view; hides while it's visible.
   Its button asks <cv-offer> to reveal the selected bundle's color & size pickers. Dismissible. */
class CurvanaStickyAtc extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('.cv-sticky');
    this.dismissBtn = this.querySelector('.cv-sticky__dismiss');
    this.addBtn = this.querySelector('.cv-sticky__cta');
    this.watchSelector = this.dataset.watch || '.cv-offer__submit';
    this.dismissed = false;

    if (this.dismissBtn) {
      this.dismissBtn.addEventListener('click', () => {
        this.dismissed = true;
        this._hide();
      });
    }
    if (this.addBtn) {
      this.addBtn.addEventListener('click', () => {
        // Point the shopper at the selected bundle's color & size pickers instead of adding blind.
        document.dispatchEvent(new CustomEvent('curvana:focus-options', { bubbles: true }));
      });
    }

    const watch = document.querySelector(this.watchSelector);
    if (!watch || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (this.dismissed) return;
          if (entry.isIntersecting) this._hide();
          else this._show();
        });
      },
      { rootMargin: '0px 0px -40px 0px' }
    );
    this.observer.observe(watch);
  }

  _show() { if (this.bar) this.bar.classList.add('is-visible'); }
  _hide() { if (this.bar) this.bar.classList.remove('is-visible'); }

  disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
}
customElements.define('cv-sticky-atc', CurvanaStickyAtc);
